(function Module() {
	'use strict';

	var moment = require('moment');	//	time utilities
	var log = require('parnell-log');

	module.exports = {
		apply: function apply(app, appFactory, appName) {
			// required appFactory properties:
			//    FPF/FOF.state.current.url

			function ApplicationInsightsFactory($state, $rootScope, cookies, api, appFactory) {
				var self = this;

				function getPersonId() {
					var personId = null;

					if (appName === 'Fetch Pro') {
						return _.get(cookies, 'profile.person.personId', null) || null;
					} else if (appName === 'Fetch Owner') {
						return _.get(cookies, 'parent.personId', null) || null;
					}

					return null;
				}
				function getHin() {
					return _.get(cookies, 'clinic.hin', null) || null;
				}
				function getSessionId() {
					return _.get(cookies, 'session.sessionId', null) || null;
				}
				function getOptions() {
					var options = {
						personId: getPersonId(),
						sessionId: getSessionId(),
						hin: getHin(),
						deviceId: null
					};

					return options;
				}

				self.clearSession = function clearSession() {
					cookies.clear('session');
				};

				self.createSession = function createSession(callback) {
					var options = getOptions();
					options.sessionId = null;
					options.createdBy = appName;

					api.createSession(options, function sessionCreated(err, sessionId) {
						if (err) {
							return log.error('Error creating session: ' + err);
						}

						cookies.session.sessionId = sessionId;
						cookies.save();

						if (callback && _.isFunction(callback)) {
							callback();
						}
					});
				};

				self.updateSession = function updateSession(callback) {
					var options = getOptions();
					options.modifiedBy = appName;

					api.updateSession(options, function sessionUpdated(err, result) {
						if (err) {
							return log.error('Error updating session: ' + err);
						}
					});
				};

				self.trackPageView = function trackPageView(pageName) {
					var options = getOptions();
					options.pageViewDateTime = +moment();

					if (appInsights) {
						appInsights.trackPageView(pageName, appFactory.state.current.url, options);
					}
				};

				self.trackEvent = function trackPageView(eventName, eventArgs) {
					if (appInsights) {
						appInsights.trackEvent(eventName, eventArgs);
					}
				};

				self.trackVideoPlaying = function trackVideoPlaying(videoName) {
					var options = getOptions();
					options.videoName = videoName;
					options.url = appFactory.state.current.url;

					if (appInsights) {
						appInsights.trackEvent('Video Started', options);
					}
				};

				self.trackVideoPaused = function trackVideoPaused(videoName) {
					var options = getOptions();
					options.videoName = videoName;
					options.url = appFactory.state.current.url;

					if (appInsights) {
						appInsights.trackEvent('Video Paused', options);
					}
				};

				self.trackVideoEnded = function trackVideoEnded(videoName) {
					var options = getOptions();
					options.videoName = videoName;
					options.url = appFactory.state.current.url;

					if (appInsights) {
						appInsights.trackEvent('Video Ended', options);
					}
				};

				// TODO: Remove this eventually (for debugging only)
				window.AIF = self;

				return self;
			}

			app.factory('ApplicationInsightsFactory', ['$state', '$rootScope', 'CookieFactory', 'ApiFactory', appFactory, ApplicationInsightsFactory]);
		}
	};
})();
